import { ChangeDetectionStrategy, Component, OnChanges, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';

@Component({
  selector: 'app-view-lo-signatures',
  templateUrl: './view-lo-signatures.component.html',
  styleUrls: ['./view-lo-signatures.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewLOSignaturesComponent implements OnChanges {

  report = input.required<any>();
  forests: string[] = []

  pageLoaded = false;

  reg = APP_CONSTANTS.URL_REGEX;

  constructor(
    public dialog: MatDialog,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {

  }

  ngOnChanges(): void {
    this.findSignatures();
  }

  findSignatures(): void {
    this.report().signatures?.forEach((signature: any) => {
      let forest = this.report().forests.find((forest: any) => {
        return forest.forest_name == signature.signature
      })
      if (forest) {
        forest.signature = signature
      }
    })
  }
}
